module.exports = __webpack_public_path__ + "static/media/logo.ee7cd8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 160
// module chunks = 1